import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogService, Pix2remPipe } from '@my7n/ui';
import { PersonalDetailsEmailUpdateDialogComponent } from './personal-details-email-update-dialog/personal-details-email-update-dialog.component';
import { UserProfileFacadeService } from '../../../../services/facades/user-profile-facade.service';
// add pix2rem function



@Component({
    selector: 'personal-details-email-update',
    templateUrl: './personal-details-email-update.component.html',
    styleUrls: ['./personal-details-email-update.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PersonalDetailsEmailUpdateComponent {
  @Input() email: string;

  constructor(
    private dialog: MatDialogService,
    private pix2remPipe: Pix2remPipe,
    private userDetailsFacade: UserProfileFacadeService
  ) {}



  showEditModal() {
    // Reset any previous email update state to ensure a clean slate when opening the dialog
    this.userDetailsFacade.resetEmailUpdate();

    this.dialog.openResponsiveDialog(PersonalDetailsEmailUpdateDialogComponent, {
      data: { currentEmail: this.email },
      maxWidth: this.pix2remPipe.transform(440)
    });
  }
}
